/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItDataTypeBooleanDto } from './TrackItDataTypeBooleanDto';
import {
    instanceOfTrackItDataTypeBooleanDto,
    TrackItDataTypeBooleanDtoFromJSON,
    TrackItDataTypeBooleanDtoFromJSONTyped,
    TrackItDataTypeBooleanDtoToJSON,
} from './TrackItDataTypeBooleanDto';

/**
 * @type EnumerationTrackItDataTypeFilterDtoDataType
 * 
 * @export
 */
export type EnumerationTrackItDataTypeFilterDtoDataType = TrackItDataTypeBooleanDto;


export function EnumerationTrackItDataTypeFilterDtoDataTypeFromJSON(json: any): EnumerationTrackItDataTypeFilterDtoDataType {
    return EnumerationTrackItDataTypeFilterDtoDataTypeFromJSONTyped(json, false);
}

export function EnumerationTrackItDataTypeFilterDtoDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationTrackItDataTypeFilterDtoDataType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TrackItDataTypeBooleanDtoFromJSONTyped(json, true) };
    return  TrackItDataTypeBooleanDtoFromJSONTyped(json, true);
}

export function EnumerationTrackItDataTypeFilterDtoDataTypeToJSON(value?: EnumerationTrackItDataTypeFilterDtoDataType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTrackItDataTypeBooleanDto(value)) {
        return TrackItDataTypeBooleanDtoToJSON(value as TrackItDataTypeBooleanDto);
    }

    return {};
}

/**
 * Check if a given object implements the EnumerationTrackItDataTypeFilterDtoDataType interface.
 */
export function instanceOfEnumerationTrackItDataTypeFilterDtoDataType(value: any): value is EnumerationTrackItDataTypeFilterDtoDataType {
    if (instanceOfTrackItDataTypeBooleanDto(value)) return true;
    return false;
}

